import { ICON } from "../../Icons/Icons";
import { getEmojiList } from "../../engine/helpers/chatHelper";

export const singleChatPanel = (data) =>
  `
<div class="chat-container keyboard-responsive-modal" id="${data.id}">
  <div class="header">
    <div class="header-left">
      <button class="back-button" aria-label="Go back">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.00483 11.6175C3.9563 11.7345 3.92935 11.8628 3.92896 11.9973L3.92896 12.0033C3.92972 12.2582 4.02734 12.5129 4.22184 12.7074L11.2929 19.7784C11.6834 20.169 12.3166 20.169 12.7071 19.7784C13.0976 19.3879 13.0976 18.7548 12.7071 18.3642L7.34316 13.0003H19.0711C19.6234 13.0003 20.0711 12.5526 20.0711 12.0003C20.0711 11.448 19.6234 11.0003 19.0711 11.0003L7.34316 11.0003L12.7071 5.63631C13.0976 5.24578 13.0976 4.61262 12.7071 4.22209C12.3166 3.83157 11.6834 3.83157 11.2929 4.22209L4.22233 11.2927L4.21973 11.2953C4.1249 11.3907 4.05327 11.5004 4.00483 11.6175Z" fill="white"/>
        </svg>
      </button>
      <h1 class="room-title">${data.name}</h1>
    </div>
    <div class="header-actions">
      <button class="action-button action-button--icon-three-dots" aria-label="Close chat">
        ${ICON.THREE_DOTS}
      </button>
      <button class="action-button" aria-label="Chat options">
        ${ICON.CLOSE}
      </button>
    </div>
  </div>
  <div class="messages-container">
    <div class="message-sent">
      <div class="message-content">
        <div class="message-text" tabindex="0" role="article" aria-label="Message content">
          Hey @Robert Rassbichler. I can't get into the room anymore today.
        </div>
        <div class="message-meta">
          <div class="meta-spacer"></div>
          <time class="timestamp">2:08 PM</time>
        </div>
      </div>
    </div>
    <div class="message-received">
      <div class="message-content">
        <div class="sender-name">
          <div class="sender-text">Robert Rassbichler</div>
        </div>
        <p class="received-text">Not yet, we'll be there starting tomorrow.</p>
        <div class="received-meta">
          <div class="received-spacer"></div>
          <time class="received-timestamp">2:12 PM</time>
        </div>
      </div>
    </div>
  </div>
  <div class="input-container">
    <form class="message-input">
      <label for="messageInput" class="visually-hidden">Write a message</label>
      <input type="text" id="messageInput" class="input-placeholder" placeholder="Write a message…" />
      <div class="input-actions">
        <svg class="icon-emoji" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.63636 12C4.63636 7.93318 7.93318 4.63636 12 4.63636C16.0668 4.63636 19.3636 7.93318 19.3636 12C19.3636 16.0668 16.0668 19.3636 12 19.3636C7.93318 19.3636 4.63636 16.0668 4.63636 12ZM12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM8.23633 12.9818C8.59669 12.7115 9.10743 12.7835 9.37922 13.142L9.38301 13.1469C9.38788 13.153 9.39714 13.1645 9.41068 13.1807C9.4378 13.213 9.48176 13.2634 9.54168 13.3259C9.6622 13.4517 9.84329 13.6223 10.0778 13.7928C10.5499 14.1362 11.2027 14.4545 12 14.4545C12.7973 14.4545 13.45 14.1362 13.9221 13.7928C14.1566 13.6223 14.3377 13.4517 14.4583 13.3259C14.5182 13.2634 14.5621 13.213 14.5893 13.1807C14.6028 13.1645 14.612 13.153 14.6169 13.1469L14.6207 13.142C14.8925 12.7835 15.4032 12.7115 15.7636 12.9818C16.1251 13.2529 16.1984 13.7658 15.9272 14.1273L15.2727 13.6363C15.9272 14.1273 15.927 14.1275 15.9268 14.1278L15.9264 14.1284L15.9255 14.1296L15.9232 14.1326L15.9173 14.1403L15.8999 14.1626C15.8858 14.1804 15.8667 14.204 15.8427 14.2326C15.7947 14.2898 15.7268 14.3673 15.6397 14.4581C15.4662 14.6392 15.2126 14.8777 14.8846 15.1162C14.2317 15.591 13.2481 16.0909 12 16.0909C10.7518 16.0909 9.76819 15.591 9.11533 15.1162C8.78732 14.8777 8.53376 14.6392 8.36024 14.4581C8.27315 14.3673 8.20524 14.2898 8.15726 14.2326C8.13324 14.204 8.11414 14.1804 8.10003 14.1626L8.0826 14.1403L8.07671 14.1326L8.07446 14.1296L8.07352 14.1284L8.07309 14.1278C8.07289 14.1275 8.07269 14.1273 8.72724 13.6363L8.07269 14.1273C7.80157 13.7658 7.87484 13.2529 8.23633 12.9818ZM8.72729 9.54547C8.72729 9.0936 9.0936 8.72729 9.54547 8.72729H9.55365C10.0055 8.72729 10.3718 9.0936 10.3718 9.54547C10.3718 9.99734 10.0055 10.3637 9.55365 10.3637H9.54547C9.0936 10.3637 8.72729 9.99734 8.72729 9.54547ZM14.4545 8.72729C14.0027 8.72729 13.6364 9.0936 13.6364 9.54547C13.6364 9.99734 14.0027 10.3637 14.4545 10.3637H14.4627C14.9146 10.3637 15.2809 9.99734 15.2809 9.54547C15.2809 9.0936 14.9146 8.72729 14.4627 8.72729H14.4545Z" fill="#A1A7B4"/>
        </svg>
        <svg class="icon-send" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M4.70051 3.19511C5.09434 3.12491 5.5003 3.18251 5.85906 3.35949L5.86695 3.36339L20.1274 10.6077C20.3433 10.7175 20.525 10.8851 20.6516 11.0915C20.7768 11.2958 20.8438 11.5304 20.8452 11.7698C20.8452 11.7723 20.8453 11.7748 20.8453 11.7773L20.8452 11.78C20.8448 12.0214 20.7778 12.2581 20.6516 12.4639C20.525 12.6704 20.3437 12.8378 20.1278 12.9476L5.85908 20.2058C5.50032 20.3827 5.09434 20.4403 4.70051 20.3701C4.30669 20.2999 3.94563 20.1056 3.67012 19.8155C3.39461 19.5255 3.21908 19.155 3.16918 18.758C3.11929 18.3611 3.19765 17.9587 3.39281 17.6095C3.39764 17.6008 3.40264 17.5923 3.40781 17.5838L6.96147 11.7777L3.4081 5.98186C3.40283 5.97326 3.39773 5.96455 3.39281 5.95574C3.19765 5.60654 3.11929 5.20407 3.16918 4.80716C3.21908 4.41025 3.39461 4.0397 3.67012 3.74966C3.94563 3.45963 4.30669 3.26531 4.70051 3.19511ZM18.3226 11.0273L5.19255 4.7033C5.12151 4.66901 5.04144 4.65798 4.96374 4.67184C4.88497 4.68587 4.81276 4.72474 4.75766 4.78275C4.70255 4.84075 4.66745 4.91486 4.65747 4.99424C4.64795 5.06996 4.66177 5.14668 4.69693 5.21421L8.43601 11.0273H18.3226ZM8.39884 12.5273H18.3231L5.1924 18.862C5.1214 18.8962 5.04139 18.9072 4.96374 18.8934C4.88497 18.8793 4.81276 18.8405 4.75766 18.7825C4.70255 18.7244 4.66745 18.6503 4.65747 18.571C4.64794 18.4952 4.66179 18.4184 4.69703 18.3508L8.39884 12.5273Z" fill="#A1A7B4"/>
        </svg>
      </div>
      <div class="message-input__emoji-menu" style="display: none;">
        ${getEmojiList().reduce((acc, emoji, index) => {
    if (index % 7 === 0) acc.push([])
    acc[acc.length - 1].push(emoji)
    return acc
  }, []).map((emojiList) => `
          <div class="message-input__emoji-menu__group">
            ${emojiList.map((emoji) => `<div class="message-input__emoji-menu__item">${emoji}</div>`).join("")}
          </div>
        `).join("")}
      </div>
    </form>
  </div>
</div>
`


export const messageSent = ({ text, timestamp }) => `
  <div class="message-sent">
    <div class="message-content">
      <div class="message-text" tabindex="0" role="article" aria-label="Message content">
        ${text}
      </div>
      <div class="message-meta">
        <div class="meta-spacer"></div>
        <time class="timestamp">${timestamp}</time>
      </div>
    </div>
  </div>
`;

export const messageReceived = ({ text, senderName, timestamp, senderId }) => `
  <div class="message-received">
    <div class="message-content">
      <div class="sender-name">
        <div class="sender-text" data-participant-id="${senderId}">${senderName}</div>
      </div>
      <p class="received-text">${text}</p>
      <div class="received-meta">
        <div class="received-spacer"></div>
        <time class="received-timestamp">${timestamp}</time>
      </div>
    </div>
  </div>
`;

export const messageReceivedPvt = ({ text, timestamp }) => `
  <div class="message-received">
    <div class="message-content">
      <p class="received-text">${text}</p>
      <div class="received-meta">
        <div class="received-spacer"></div>
        <time class="received-timestamp">${timestamp}</time>
      </div>
    </div>
  </div>
`;
